import mdcAutoInit from "@material/auto-init";
import { MDCFormField } from "@material/form-field";
import { MDCTextField } from "@material/textfield";
import { MDCSelect } from "@material/select";
import { MDCMenu } from "@material/menu";
import { MDCCheckbox } from "@material/checkbox";
import { MDCRadio } from "@material/radio";
import { MDCSwitch } from "@material/switch";
import { MDCTabBar } from "@material/tab-bar";
import { MDCDialog } from "@material/dialog";
import { MDCRipple } from "@material/ripple";
import { MDCIconButtonToggle } from "@material/icon-button";

mdcAutoInit.register("MDCFormField", MDCFormField);
mdcAutoInit.register("MDCTextField", MDCTextField);
mdcAutoInit.register("MDCSelect", MDCSelect);
mdcAutoInit.register("MDCMenu", MDCMenu);
mdcAutoInit.register("MDCCheckbox", MDCCheckbox);
mdcAutoInit.register("MDCRadio", MDCRadio);
mdcAutoInit.register("MDCSwitch", MDCSwitch);
mdcAutoInit.register("MDCTabBar", MDCTabBar);
mdcAutoInit.register("MDCDialog", MDCDialog);
mdcAutoInit.register("MDCIconButtonToggle", MDCIconButtonToggle);

/**
 *  live:wire works off the input events which MDCSelect hides
 *  this code looks to resolve this issue.
 *  @param {Event} event
 */
function propagateChange(event) {
    var inputEvent = new Event("input", {
        bubbles: true,
        cancelable: true
    });
    event.target.querySelector("input").dispatchEvent(inputEvent);

    var changeEvent = new Event("change", {
        bubbles: true,
        cancelable: true
    });
    event.target.querySelector("input").dispatchEvent(changeEvent);
}

/**
 * @param {Node} doc
 */
function init(doc) {
    try {
        mdcAutoInit(doc);
    } catch (e) {
        // Helps debug.
        console.log(e);
    }

    const selectElms = doc.querySelectorAll(".mdc-select");

    for (const selectEl of doc.querySelectorAll(".mdc-select")) {
        getMDCControl(selectEl).listen("MDCSelect:change", propagateChange);
    }

    // Initialize MDC Ripple for all icon buttons
    const iconButtonRipples = [].map.call(
        doc.querySelectorAll(".mdc-icon-button"),
        function(el) {
            let iconButtonRipple = new MDCRipple(el);
            iconButtonRipple.unbounded = true;
            return iconButtonRipple;
        }
    );
}

/**
 * @param {HTMLElement} el
 */
function get_mdc_wrapper(el) {
    do {
        if (el.dataset.mdcAutoInit) {
            return el;
        }
    } while ((el = el.parentElement));
    return null;
}

/**
 * @param {Node} el
 */
function getMDCControl(el) {
    if (!el.dataset.mdcAutoInit) {
        throw "Tried to get Control from uninitialised MDC component.";
    }
    return el[el.dataset.mdcAutoInit];
}

/**
 * @param {Node} doc
 */
function deinit(doc) {
    for (const el of doc.querySelectorAll("[data-mdc-auto-init-state]")) {
        var controller = getMDCControl(el);
        if (controller) {
            controller.unlisten("MDCSelect:change", propagateChange);
            controller.destroy();
        }
    }
}

// TODO: This is a hack to get the MDCSelect to update its value. (Required?)
// function MDCCheckboxSetValidity(checkboxInput) {
//     var input = checkboxInput;
//     if (this && this.type.toLowerCase() === "checkbox") {
//         input = this;
//     }

//     if (input.parentNode && input.parentNode.MDCCheckbox) {
//         if (input.parentNode.MDCCheckbox.hasOwnProperty("root")) {
//             if (!input.validity.valid) {
//                 input.parentNode.MDCCheckbox.root.classList.add(
//                     "mdc-checkbox--invalid"
//                 );
//             } else {
//                 input.parentNode.MDCCheckbox.root.classList.remove(
//                     "mdc-checkbox--invalid"
//                 );
//             }
//         }
//     }
// }

function MDCSelectFocus(control) {
    control.handleFocus();
    control.selectAnchor.focus();
}

function MDCSwitchFocus(control) {
    control.ripple_.foundation.handleFocus();
}

function MDCFocus(control) {
    if (!control) {
        return;
    }
    if (control.focus) {
        control.focus();
        return;
    }
    if (control instanceof MDCSwitch) {
        MDCSwitchFocus(control);
    }
    if (control instanceof MDCSelect) {
        MDCSelectFocus(control);
    }
}

window.MaterialQueue = [];

function MDCSetValue(control, value) {
    if (control.setValue) {
        control.setValue(value);
    } else {
        control.value = value;
    }
}

window.addEventListener("DOMContentLoaded", function() {
    try {
        init(document);
    } catch (e) {
        console.log(e);
    }

    Livewire.hook("message.processed", (message, component) => {
        init(component.el);
    });
    Livewire.hook("message.received", (message, component) => {
        deinit(component.el);
    });
    window.addEventListener("OfferSubmitted", event => {
        var anchor = document.querySelector(".o-formContainer");
        anchor.scrollIntoView();
    });
    Livewire.hook(
        "element.updating",
        /**
         * @param {HTMLElement} fromEl
         * @param {HTMLElement} toEl
         */ (fromEl, toEl, component) => {
            var formMDCWrapper = get_mdc_wrapper(fromEl);
            if (formMDCWrapper === null) {
                return;
            }
            var fromControl = getMDCControl(formMDCWrapper);

            if (fromControl instanceof MDCFormField) {
                return;
            }

            var queueItemData = {};

            if (fromControl instanceof MDCTextField) {
                queueItemData.value = fromControl.value;
            }
            if (fromControl instanceof MDCSwitch) {
                queueItemData.value = fromControl.checked;
            }
            if (fromControl instanceof MDCSelect) {
                queueItemData.open = fromControl.foundation.isMenuOpen;
            }
            queueItemData.func = function(queueItem) {
                var control = null;
                var mdcWrapper = get_mdc_wrapper(toEl);
                if (mdcWrapper !== null) {
                    control = getMDCControl(mdcWrapper);
                }
                if (!control) {
                    control = getMDCControl(get_mdc_wrapper(fromEl));
                }
                if (queueItem.value) {
                    MDCSetValue(control, queueItem.value);
                }

                if (
                    document.activeElement === toEl ||
                    document.activeElement === fromEl
                ) {
                    MDCFocus(control);
                }

                if (queueItem.hasOwnProperty("open")) {
                    if (queueItem.open) {
                        control.foundation.adapter.openMenu();
                    }
                }
            };
            window.MaterialQueue.push(queueItemData);
        }
    );
});
document.addEventListener("MDCAutoInit:End", function() {
    const mapper = (input, w) => (
        (w = input.closest("[data-mdc-auto-init-state]")),
        { input, wrapper: w, control: w[w.dataset.mdcAutoInit] }
    );
    // invalidate inputs
    Array.from(document.querySelectorAll("input.has-error"))
        .map(mapper)
        .forEach(({ control }) => {
            control.useDefaultValidation = false;
            control.useNativeValidation = false;
            control.valid = false;
        });

    // TODO: This is a hack to get the MDCSelect to update its value. (Required?)
    // Custom error handling for checkbox material element
    // Array.from(document.querySelectorAll(".mdc-checkbox input"))
    //     .map(mapper)
    //     .forEach(({ control }) => {
    //         var input = control.root.querySelector("input");
    //         input.addEventListener("change", MDCCheckboxSetValidity);
    //         input.addEventListener("blur", MDCCheckboxSetValidity);

    //         var form = input.form;
    //         if (!form.MDCCheckboxValidityListener) {
    //             form.addEventListener("submit", function () {
    //                 var checkboxes = this.querySelectorAll(
    //                     ".mdc-checkbox input"
    //                 );
    //                 checkboxes.forEach(function (item) {
    //                     MDCCheckboxSetValidity(item);
    //                 });
    //             });
    //             form.MDCCheckboxValidityListener = true;
    //         }
    //     });

    while (window.MaterialQueue.length > 0) {
        var queueItem = window.MaterialQueue.pop();
        queueItem.func(queueItem);
    }
});
